import { render, staticRenderFns } from "./TableSort.vue?vue&type=template&id=6b4787b7&scoped=true&"
import script from "./TableSort.vue?vue&type=script&lang=js&"
export * from "./TableSort.vue?vue&type=script&lang=js&"
import style0 from "./TableSort.vue?vue&type=style&index=0&id=6b4787b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4787b7",
  null
  
)

export default component.exports